<div class="container">
	<div class="login-body">
		<div id="header-logo">
			<div class="login-section">
				<img *ngIf="pageDetails?.ibpLogoPath" class="login-logo" [src]="pageDetails?.ibpLogoPath" alt="Logo"/>
                <img *ngIf="pageDetails?.existsInstituteLogo" class="institute-logo" [src]="pageDetails?.instituteLogoPath" alt="Institute"/>
            </div>
		</div>

		<form id="one-time-password-form" class="login-form" (keyup.enter)="doVerifyOTP()">
			<div>
				<h1 jhiTranslate="login.otp.title">One Time Password</h1>
			</div>
			<p jhiTranslate="login.otp.enter.code">Please enter the verification code sent to your registered email:</p>
			<div class="login-form-control" [ngClass]="{ 'login-validation-error': this.errorFields.includes('otpCode') }">
				<input class="js-otp-code login-otp-input login-flat-control" name="otpCode" type="number" autocomplete="off"
					   [(ngModel)]="otpCode" [maxlength]="6" />
				<p *ngIf="!this.enableResendLink" class="pt-2 float-start">{{ 'login.otp.resend.in' | translate}} {{ this.timeRemaining * 1000 | date:'mm:ss' }}</p>
				<div *ngIf="this.enableResendLink" class="pt-2 float-start">
					<span *ngIf="isLoading" class="throbber throbber-btn"></span>
					<a *ngIf="!isLoading" href="javascript:void(0)" (click)="doCreateOTP()" jhiTranslate="login.otp.resend">Resend OTP</a>
				</div>
			</div>
			<div *ngIf="!this.isFormValid" class="row js-login-error">
				<div class="col-1"><span class="fa login-warning-icon">&#xf12a;</span></div>
				<span class="js-login-error-text col-11">{{this.errorMessage}}</span>
			</div>
			<button class="js-verify-otp-submit login-submit login-flat-control login-clickable" formnovalidate="" type="button"
					(click)="doVerifyOTP()">
				<span class="login-submit-label" jhiTranslate="login.verify">Verify</span>
				<span class="throbber"></span>
			</button>
		</form>
		<div id="message">
			<div ng-if="pageDetails != null && pageDetails.footerMessage != ''">
				<div [textContent]="pageDetails.footerMessage" class="login-footer-message">
				</div>
			</div>
		</div>

		<div id="footer">
			<div class="login-footer">
				<img *ngIf="pageDetails?.ibpLogoPath" class="login-footer-logo" [src]="pageDetails?.ibpLogoPath" alt="Logo"/>
				<div class="login-footer-body">
					<span jhiTranslate="about.version.prefix"></span><span [innerText]="pageDetails.version"></span> &bull;
					{{'login.provider.message' | translate}} <a href="https://www.integratedbreeding.net/" jhiTranslate="login.provider.ibp">Integrated Breeding Platform</a>
				</div>
			</div>
			<jhi-languange-selector></jhi-languange-selector>
		</div>
	</div>
</div>
